export default "__VITE_ASSET__CjWx5MQU__"